import { Components } from "@mui/material/styles";

export const MuiSwitch: Components["MuiSwitch"] = {
    defaultProps: {},
    styleOverrides: {
        root: {
            padding: "0",
            width: "auto",
            height: "auto",

            variants: [
                {
                    props: { size: "small" },
                    style: {
                        "& .MuiSwitch-thumb": {
                            width: "20px",
                            height: "20px",
                        },
                        "& .MuiSwitch-track": {
                            width: "44px",
                            height: "24px",
                        },

                        "& .MuiSwitch-switchBase": {
                            padding: "2px",
                        },

                        "& .MuiSwitch-switchBase.Mui-checked": {
                            transform: "translateX(20px)",
                        },
                    },
                },
            ],
        },
        thumb: {
            width: "28px",
            height: "28px",
            margin: "0",
            backgroundColor: "white",
            boxShadow: "none",
        },
        track: {
            width: "60px",
            height: "32px",
            borderRadius: "9999px",
            backgroundColor: "var(--mui-palette-gray-300)",
            opacity: 1,
        },
        switchBase: {
            padding: "2px",

            "&.Mui-checked": {
                transform: "translateX(28px)",
            },

            "&.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "var(--mui-palette-green-500)",
                opacity: 1,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.4,
            },
        },
    },
};
